(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tazty-product-accordions"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:block:select', event => {
    const row = event.target.closest('[data-shipping-destination]');
    const accordion = row?.closest('.tz-product-tabs__item');
    if (accordion) accordion.open = true;
  });

  } catch(e) { console.error(e); }
})();
})();
